/**
 * NoAccessPage.js — RC 1.30.B0 zero-workspace fallback.
 *
 * Reached only if the user is authenticated with a profile but the
 * derivation returned `allowed_workspaces: []`. Should be extremely
 * rare under the default column values (candidate_access=true), but
 * the spec requires a defined destination for the "no workspace"
 * case.
 */
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

export default function NoAccessPage() {
  const { signOut } = useAuth();
  return (
    <div
      className="mx-auto max-w-xl py-24 px-4 text-center"
      data-testid="no-access-page"
    >
      <ShieldAlert className="mx-auto mb-4 h-10 w-10 text-ndor-ink-muted" />
      <h1 className="text-xl font-semibold text-ndor-ink">
        No workspace access
      </h1>
      <p className="mt-2 text-sm text-ndor-ink-muted">
        Your account doesn't have any workspace enabled yet. An admin
        needs to grant you candidate or employer access before you
        can continue.
      </p>
      <Button
        variant="outline"
        className="mt-6"
        onClick={signOut}
        data-testid="no-access-signout"
      >
        Sign out
      </Button>
    </div>
  );
}
